<template>
    <div class="alarm-management">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "AlarmManagement",
  data() {
    return {};
  }
};
</script>
